import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from "react-redux";
import compose from 'recompose/compose';
import api from 'api';

// Material helpers
import { withStyles } from '@material-ui/core';

// Material components
import { Typography, TextField, CircularProgress, Button } from '@material-ui/core';

// Shared components
import { Portlet, PortletContent, PortletFooter } from 'components';

// Component styles
import styles from './styles';

class SupportTable extends Component {
    state = {
        values: {
          topic:'',
          description:''
        },
        loading: false
    };
    handleFieldChange = (field, value) => {
        const newState = { ...this.state };
        newState.values[field] = value;
        this.setState(newState);
      };
    
    handleSave = async () => {
        try {
            const { topic, description } = this.state.values;
            const { cid } = this.props.auth.user;
            this.setState({loading:true});
            await api.sendCustomerSupport({cid,topic,description});
            this.setState({loading:false});
            window.alert('Support Request Send');
        } catch (error) {
            console.error(error);
        }
    };  
  render() {
    const { classes, className, ...rest } = this.props;
    const { values, loading } = this.state;

    const rootClassName = classNames(classes.root, className);

    return (
      <Portlet
        {...rest}
        className={rootClassName}
      >
        <PortletContent>
          <div className={classes.details}>
            <Typography variant="h4">Send Request for Customer Support</Typography>
          </div>
          <form
            autoComplete="off"
            noValidate
          >
            <div className={classes.field}>
                <TextField
                className={classes.textField}
                label="Topic"
                fullWidth
                value={values.topic}
                variant="outlined"
                onChange={event =>
                    this.handleFieldChange('topic', event.target.value)
                }
                />
            </div>
            <div className={classes.field}>
                <TextField
                className={classes.textField}
                label="Description"
                multiline
                fullWidth
                rows="20"
                value={values.description}
                variant="outlined"
                onChange={event =>
                    this.handleFieldChange('description', event.target.value)
                }
                />
            </div>
          </form>
        </PortletContent>
        <PortletFooter className={classes.portletFooter}>
        {loading ? (
          <CircularProgress className={classes.progress} />
        ) : (
          <Button
            color="primary"
            variant="contained"
            onClick={this.handleSave}
          >
            Send
          </Button>
        )}
        </PortletFooter>
      </Portlet>
    );
  }
}

SupportTable.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(SupportTable);